import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { toHttpParams } from "src/app/core/helpers/http-params-extensions"
import { HttpClient } from "@angular/common/http"
import { SubjectCreateUpdateRequest } from "../models/subject/subject-create-update-request"

@Injectable({
  providedIn: "root",
})
export class SubjectService {
  private get_subject_paginate_url: string
  private put_subject_url: string
  private post_subject_url: string
  private delete_subject_url: string
  private get_subjects_options_url: string


  private buildUrls(subjectUrl: string) {
    this.get_subject_paginate_url =
      subjectUrl +
      environment.endpointSubjectGateway.routes.get_subject_paginate

    this.put_subject_url =
      subjectUrl + environment.endpointSubjectGateway.routes.put_subject

    this.post_subject_url =
      subjectUrl + environment.endpointSubjectGateway.routes.post_subject

    this.delete_subject_url =
      subjectUrl + environment.endpointSubjectGateway.routes.delete_subject

      this.get_subjects_options_url =
      subjectUrl + environment.endpointSubjectGateway.routes.get_subjects_options
  }

  constructor(private http: HttpClient) {
    this.buildUrls(environment.endpointSubjectGateway.url)
  }

  getPaginate(data) {
    let params = toHttpParams(data);
    return this.http.get(this.get_subject_paginate_url, { params })
  }

  post(model: SubjectCreateUpdateRequest) {
    return this.http.post(this.post_subject_url, model)
  }

  put(model: SubjectCreateUpdateRequest) {
    return this.http.put(
      this.put_subject_url.replace("{subjectId}", model.id),
      model
    )
  }

  delete(subjectId: string) {
    return this.http.delete(
      this.delete_subject_url.replace("{subjectId}", subjectId)
    )
  }

  getSubjectsOptions() {
    return this.http.get(this.get_subjects_options_url);
  }
}
